import styled from "styled-components";

import Text from "@/components/Text";
import { FC } from "react";

const CountCircle = styled.span`
  color: white;
  background: ${({ theme }) => theme.colors.error};
  border-radius: 9px;
  margin: 0 4px;
  flex-shrink: 0;
  padding: 0 5px;
  height: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface Props {
  count?: number;
}

const NavigationItemsCount: FC<Props> = ({ count }) => {
  return (
    <CountCircle>
      <Text as="span" $color="white" $type="extraSmall">
        {count}
      </Text>
    </CountCircle>
  );
};

export default NavigationItemsCount;
